import React from "react"
import { motion } from "framer-motion"
import { cardVariants } from "src/animation/card.variants"
import AppearWhenVisible from "src/components/animated/AppearWhenVisible"

export default function Card({ children }) {
  return (
    <motion.div variants={cardVariants} whileHover="hover" className="card">
      <AppearWhenVisible>{children}</AppearWhenVisible>
    </motion.div>
  )
}
